module.exports = __webpack_public_path__ + "img/btn2.5959d0bc.png";